import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DnPrimaryBtnComponent } from './dn-primary-btn.component';
import { MatButtonModule } from '@angular/material/button';
import { DnLoaderModule } from '../dn-loader/dn-loader.module';

@NgModule({
  declarations: [DnPrimaryBtnComponent],
  imports: [CommonModule, MatButtonModule, DnLoaderModule],
  exports: [DnPrimaryBtnComponent],
})
export class DnPrimaryBtnModule {}
